import { Component } from '@angular/core';


@Component({
    selector: 'ui-toolbar-title',
    styles: [
        `
        :host {
            font-size: 1.2rem;
            font-weight: bold;
            align-items: center;
            flex-shrink: 1;
        }
        `,
    ],
    template: `
        <ng-content></ng-content>
    `
})
export class ToolbarTitleComponent {}
